document.addEventListener('DOMContentLoaded', () => {
  const topbar = document.querySelector('.topbar');
  const header = document.querySelector('.header');
  const body = document.querySelector('body');

  if (topbar && header) {
    header.classList.add('extendedHeader');
    body.classList.add('extendedHeader');
  }
});
